/**
 * Created by rhinov8e on 20/11/2015.
 *
 * UI State when a wall is cut to display dimensions
 */
import { UiState, UiStateEnum } from "./UiState";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { math, Wall } from "@rhinov/savane-js";


export class CutDimensionState extends UiState {

    _currentWallDimension: Wall;
    cursorPositionWithoutSnap = math.vec3.create();

    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3, wall: Wall) {
        super(cursorPosition, cocosPosition);
        // Store current wall to display dimensions for
        this._currentWallDimension = wall;
        
        if (cursorPosition !== undefined) {
            math.vec3.copy(this.cursorPositionWithoutSnap, cursorPosition);
            this.setSelected();
        }
    }

     // Return from global enum
    getUiState(): number {
        return UiStateEnum.uiCutDimensionState;
    }

    // Called when the mouse moves in this state
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        // Store cursor and cocos positions
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;
        // Store cursor without snap now (it will be modified by the setSelected method below)
        this.cursorPositionWithoutSnap = math.vec3.clone(cursorPosition);
        // Call set selected to get user selection and hovering (see UiIdleState)
        this.setSelected();

        // Still in current state ?
        if (this.getNextUiState() === this.getUiState()) {
            // Hovered entity is a wall ?
            if (this.hoverEntities !== null && this.hoverEntities.length === 1 && this.hoverEntities[0].isWallEntity()) {
                if (this._currentWallDimension.id === this.hoverEntities[0].id) {
                    GameObjectManager.drawCutDimension(this.cursorPosition, this._currentWallDimension, this.cursorPositionWithoutSnap);
                }
                else {
                    GameObjectManager.deleteCutDimension();
                    this._currentWallDimension = this.hoverEntities[0] as Wall;
                    GameObjectManager.drawCutDimension(this.cursorPosition, this._currentWallDimension, this.cursorPositionWithoutSnap);
                }

            }
            return null;
        }
        else {
            GameObjectManager.deleteCutDimension();
            return this.createNextUiState();
        }
    }
}
